export default import.meta.ROLLDOWN_FILE_URL_qmB2mqHYF4eX3pnYvuxGpw